/**
 * A record's own value at a key, never one it inherits: an equipment key, a stream key or a role is the plant's word,
 * and "constructor" or "toString" is a key like any other (#1406 review).
 */
export function own<T>(rec: Readonly<Record<string, T>> | null | undefined, key: string): T | undefined {
  return rec && Object.prototype.hasOwnProperty.call(rec, key) ? rec[key] : undefined;
}
